import React from 'react'
import {BlockComponentProps} from '../index'
import {Font} from '../../lib/font'
import {BlockBase} from '../base'
import {Column} from '../../lib/layout'
import {usePurchase} from '../../PurchaseContext'
import Container from '../Container'
import UpsellPurchaseForm from './UpsellPurchaseForm'
import PurchaseButton from '../PurchaseForm/PurchaseButton'
import PurchaseFormButton from '../PurchaseForm/PurchaseFormButton'
import {PurchaseFormBlockBase} from '../PurchaseForm'

export interface UpsellPurchaseButtonBlock
  extends BlockBase,
    PurchaseFormBlockBase {
  type: 'UpsellPurchaseButton'
  title?: {
    enabled: boolean
    text: string
    font: Font | null
    fontSize?: number
    margin: {
      top: number
      right: number
      bottom: number
      left: number
    }
  }
  purchaseButton: {
    text: string
    icon?: string | null
    iconAlign?: 'left' | 'right'
    image?: string
    margin?: {
      top: number
      right: number
      bottom: number
      left: number
    }
  }
  buttonStyle: {
    size: Column
    font: Font | null
    fontSize?: number
    backgroundColor?: string
    hoverBackgroundColor?: string
    textColor?: string
    hoverTextColor?: string
    borderRadius?: number
    borderWidth?: number
    borderColor?: string
    hoverBorderColor?: string
    height?: number
    width?: number
    disabledBackgroundColor?: string
    disabledTextColor?: string
  }
  buttonsAlignment: 'flex-start' | 'center' | 'flex-end'
  requirePhoneNumber: boolean
  errors: {
    requiredField: string
  }
  questions: {
    sameShippingAddress: string
  }
  sectionLabel?: {
    font: Font | null
    fontSize?: number
    margin: {
      top: number
      right: number
      bottom: number
      left: number
    }
  }
  summaryColumnLabel?: {
    font: Font | null
    fontSize?: number
    border: {
      width: number
      color: string
    }
  }
  customerDetailsLabel?: string
  companyNameLabel?: string
  billingSectionLabel?: string
  shippingSectionLabel?: string
  purchaseSummaryLabel?: string
  totalAmountLabel?: string
  itemLabel?: string
  cardFieldsLabel?: string
}

interface UpsellPurchaseButtonProps
  extends UpsellPurchaseButtonBlock,
    BlockComponentProps {
  TitleComponent?: React.FC<any>
  TextFieldComponent?: React.FC<any>
  ButtonComponent?: React.FC<any>
  CustomerDetailsSectionLabelComponent?: React.FC<any>
  CompanyNameLabelComponent?: React.FC<any>
  BillingFieldsLabelComponent?: React.FC<any>
  ShippingFieldsLabelComponent?: React.FC<any>
  PurchaseSummaryLabelComponent?: React.FC<any>
  TotalAmountLabelComponent?: React.FC<any>
  ItemLabelComponent?: React.FC<any>
  CardFieldsLabelComponent?: React.FC<any>
  stripeAccountId?: string
}

export default function UpsellPurchaseButton(props: UpsellPurchaseButtonProps) {
  const {padding: _padding, ButtonComponent = PurchaseFormButton} = props

  const {hasSavedCard, isProcessing, selectedTicket, submit} = usePurchase()

  if (hasSavedCard) {
    return (
      <Container {...props}>
        <PurchaseButton
          {...props}
          ButtonComponent={ButtonComponent}
          disabled={isProcessing || !selectedTicket}
          onClick={() => {
            submit()
          }}
        />
      </Container>
    )
  }

  return <UpsellPurchaseForm {...props} />
}
